import './App.css';
import {Fragment, useEffect, useState} from "react";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import {getUser, useUserDispatch, useUserState} from "./UserContext";
import Main from "./component/Main";
import SignIn from "./component/signin";
import {BuyDetail} from "./component/BuyDetail";
import {getWarehouse, useWarehouseDispatch} from "./WarehouseContext";
import {Box} from "@mui/material";
import useWindowDimensions from "./Dimension";

function App() {
  const location = useLocation();
  const [initializing, setInitializing] = useState(true)
  const history = useHistory()
  const warehouseDispatch = useWarehouseDispatch()
  const userDispatch = useUserDispatch()
  const userState = useUserState()
  const { windowHeight, windowWidth } = useWindowDimensions();

  useEffect(()=>{
    localStorage.clear()
    console.log('app init')
    getUser(userDispatch)

  }, [])

  useEffect(async ()=>{

    if(!userState.loading){
      console.log("user state changed ", userState)
      if(userState.error != null){
        if(userState.data != null && userState.data.code === 0){
          history.replace('/signin')
        }
      }else{
        // history.replace('/buy')
        await getWarehouse(warehouseDispatch)
      }

      setInitializing(false)
    }
  }, [userState.data])


  return (
    <Box sx={{height : windowHeight , backgroundColor: (theme) => theme.palette.grey[100],}}>
      {
        initializing ?
          <div/>
        :
          <Box sx={{height : '100%'}}>
            <Switch>
              {/*<Route path='/buy' component={Main}/>*/}

              <Route path='/' exact component={()=>{
                console.log('redirect')
                return <Redirect to={"/buy"}/>
              }}/>
              <Route path='/buy'>
                <Main/>
              </Route>
              <Route path='/signin' component={SignIn} exact/>
              <Route path='/detail' component={BuyDetail} exact/>
              {/*<Route path='/detail' component={RegisterView} />*/}
              {/*<Route path='/detail' component={BuyDetail} exact/>*/}
            </Switch>
          </Box>

      }
    </Box>
  );
}

export default App;
